import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryOverview() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100" data-product-shop="">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
            分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            按类型快速筛选，总有一种方式适合你的观影习惯
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 flex flex-col items-center text-center hover:border-primary-200/60 transition-all duration-300 hover:bg-primary-50/30 cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-1">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.count} 篇测评
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}